import { dateTemplate } from 'routes/Pages/GenTask/components/SharedFormFields';

export const chipperLoaderColumnData = {
  jobDocketDetails: [
    { key: 'formId', label: 'Form ID', width: 100 },

    { key: 'driverName', label: 'Driver Name', width: null },
    { key: 'truck', label: 'Truck', width: null },
    { key: 'trailer', label: 'Trailer', width: null },

    { key: 'loaderMachineTruck', label: 'Loader / Machine', width: null },

    { key: 'customerForOtherWork', label: 'Customer', width: null },
    { key: 'customerForOtherWorkOther', label: 'Other Customer', width: null },

    { key: 'fromForestSP', label: 'From Forest SP', width: null },
    { key: 'toForestSP', label: 'To Forest SP', width: null },

    { key: 'startKM', label: 'Start KM', width: null },
    { key: 'endKM', label: 'End KM', width: null },
    { key: 'totalKM', label: 'Total KM', width: null },

    { key: 'jobStartTime', label: 'Job Start Time', width: null },
    { key: 'jobEndTime', label: 'Job End Time', width: null },
    { key: 'nonChargeableTime', label: 'Non-Chargeable Time', width: null },
    { key: 'totalChargeableTime', label: 'Chargeable Time', width: null },

    { key: 'dateAndTime', label: 'Date & Time', width: null, formatter: dateTemplate },

    { key: 'notesForWHOffice', label: 'Office Notes', width: null },
    { key: 'notesCustomer', label: 'Customer Notes', width: null },
    {
      key: 'chipper_docs',
      label: 'Docs',
      isDocument: true,
      width: 120,
    },
  ],
};
